"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/TemplatesDialog/controls.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);









/* The dialog's buttons, at concept A's sizes: a 32 px pill (28 px small),
 * filled, outlined, plain or red. Lighter than the app's form buttons. */
 const DialogButton = ({ variant = 'primary', small, busy, className, disabled, children, ...rest }) => (
  _react2.default.createElement('button', {
    type: "button",
    className: _classBuilder2.default.call(void 0, 'tdlg-btn', `tdlg-btn--${variant}`, small && 'tdlg-btn--sm', className),
    disabled: disabled || busy,
    'aria-busy': busy || undefined,
    ...rest, __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}

    ,  children 
  )
); exports.DialogButton = DialogButton








/* A two-way switch drawn as one control (Use | Edit). */
 const Segmented = ({ label, value, options, onChange }) => (
  _react2.default.createElement('div', { className: "tdlg-seg", role: "group", 'aria-label': label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
    ,  options.map(o => (
      _react2.default.createElement('button', {
        key: o.value,
        type: "button",
        'aria-pressed': o.value === value,
        disabled: o.disabled,
        className: _classBuilder2.default.call(void 0, 'tdlg-seg--item', o.value === value && 'tdlg-seg--on'),
        onClick: () => onChange(o.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}

        ,  o.label 
      )
    ))
  )
); exports.Segmented = Segmented
